/**
 * Merge default API headers without dropping headers supplied by the caller.
 * ofetch normalizes request headers to a Headers instance before onRequest.
 */
export function mergeRequestHeaders(
  initial: HeadersInit | undefined,
  defaults: Record<string, string>,
): Headers {
  const headers = new Headers(initial)
  for (const [name, value] of Object.entries(defaults)) headers.set(name, value)
  return headers
}
